import { Link } from '@eika/link';
import React, { FC } from 'react';
import AttentionMessageTypes from '@eika/attention-message/src/AttentionMessageTypes';
import { IconTypes } from '@eika/icon';
import { AttentionMessage } from '@eika/attention-message';
import CardIcon from '@eika/card/src/CardIcon';
import { useTranslate } from '../../../../../hooks/useTranslate';

type SwitchSuccessProps = {
    fundName: string;
};
const SwitchSuccess: FC<SwitchSuccessProps> = ({ fundName }) => {
    const translate = useTranslate();
    return (
        <div className="switch-success">
            <CardIcon icon={IconTypes.USP_CHECKMARK_36} />
            <h2 className="paragraph">{translate('profileSwitchSuccessTitle')}</h2>
            <article className="paragraph">{translate('switchSuccessDescription', { fundName })}</article>
            <AttentionMessage
                className="pending-profile-change"
                type={AttentionMessageTypes.ATTENTION}
                text={translate('pendingProfileChange')}
                icon={IconTypes.INFO_DYN}
            />
            <div className="button-row">
                <Link linkType="button-negative" href={location.href.split('/').slice(0, -3).join('/')}>
                    {translate('backToOverview')}
                </Link>
            </div>
        </div>
    );
};

export default SwitchSuccess;
